import React, {useState} from "react";
import {PageHeader} from "../../../../components/PageHeader";
import AssetContractListType from "./subPages/AssetContractListType";
import useRequestData from "../../../../hooks/useRequestData";
import {toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import {getContractList} from "../../../../api/asset/AssetContractService";

function AssetContractList() {

    const [checked, setChecked] = useState([]);

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    const {newData, pageInfo, dataHook} =
        useRequestData((conditions, pageable) => {
            const additionalCondition = {
                dateType : conditions.dateType || "등록일"
            };
            const finalConditions = {
                ...conditions,
                ...additionalCondition
            };
            return getContractList(finalConditions, pageable);
        }, initDate, "contract");

    return (
        <>
            <div className="common-container">
                <PageHeader header={"자산계약관리"} indicator={"자산관리 > 자산재무관리 > 자산계약관리"}/>
                <AssetContractListType
                    data={newData} date={initDate}
                    pageInfo={pageInfo} dataHook={dataHook}
                    checked={{checked: checked, setChecked: setChecked}}/>
            </div>
        </>
    );
}

export default AssetContractList;